import { z } from 'zod';
const schemaContentSchema = z.union([
    z.string(),
    z.record(z.string(), z.unknown()),
]);
const modelsRecordSchema = z.record(z.string(), z.unknown()).optional();
const fieldsRecordSchema = z.record(z.string(), z.unknown()).optional();
export const smrtArtifactSchema = z.object({
    schema: schemaContentSchema,
    schemaId: z.string().uuid().optional(),
    smrtIri: z.string().min(1).optional(),
    smrtVersion: z.string().min(1).optional(),
    models: modelsRecordSchema,
    fields: fieldsRecordSchema,
});
export const parseSmrtArtifact = (value) => {
    const parsed = smrtArtifactSchema.parse(value);
    const schemaStr = typeof parsed.schema === 'string'
        ? parsed.schema
        : JSON.stringify(parsed.schema);
    return {
        ...parsed,
        schema: schemaStr,
    };
};
//# sourceMappingURL=SmrtArtifact.js.map